export function hasSeqGap(lastSeq: number, incomingSeq: number): boolean {
  if (!Number.isFinite(incomingSeq) || incomingSeq <= 0) return false;
  if (!Number.isFinite(lastSeq) || lastSeq <= 0) return false;
  if (incomingSeq <= lastSeq) return false;
  return incomingSeq > lastSeq + 1;
}
